<div *ngIf="!notViewList.includes(topItemId)">
  <mat-expansion-panel class="expansion-panel-menu" [class.selected-list-menu]="panelOpened" (opened)="onOpenPanel()"
    (closed)="onClosePanel()">
    <mat-expansion-panel-header [collapsedHeight]="'64px'" [expandedHeight]="'64px'">
      <mat-panel-title id="title"
        style="font-family: 'Roboto'; font-size: '18px';font-weight: bold; color: '#1C1F22DE'">
        {{title}}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-nav-list>
      <app-child-side-menu [inputChildren]="topChildren" [inputIsTopSideComponent]="true"
        [inputAuthorityList]="childrenAuthorityList" [inputNotViewList]="notViewList"></app-child-side-menu>
    </mat-nav-list>
  </mat-expansion-panel>
</div>